export default __webpack_public_path__ + "locales/lo-LA/Profile.json?hash=11d0c9d6db75b7c74f7d36e7136e29f7";